export default {
  dialogAriaLabel: 'Date Picker',
  prevMonth: 'Previous Month',
  nextMonth: 'Next Month',
  selectMonth: 'Select month',
  selectYear: 'Select year',
  clearDate: 'Clear selected date',
  clear: 'Clear',
};
